import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import fr from './locales/fr.json';
import en from './locales/en.json';
import de from './locales/de.json';
import it from './locales/it.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { fr: { translation: fr }, en: { translation: en }, de: { translation: de }, it: { translation: it } },
    fallbackLng: 'fr',
    supportedLngs: ['fr', 'en', 'de', 'it'],
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'ebios_language',
      caches: ['localStorage'],
    },
    interpolation: { escapeValue: false },
  });

export default i18n;
